import React from 'react';
import '../Assets/Additionalcss/Sacss.css'
import Salogo from '../Assets/Images/salogo.gif'
import { Link } from 'react-router-dom';

function Sasidebar({sidebar,openLogForm}) {

    // function removelogalstorage(){
    //     localStorage.clear()
    //   }
    return (
        <div className ={sidebar? "SA-sidebar SA-sidebar--open" : "SA-sidebar"}  id="SA-sidebar">
    <div className='SA-sidebar-title'>
        <div className='SA-sidebar-img'>
             <img src={Salogo} alt="logo"/>&nbsp;&nbsp;
            <span>Super Admin</span>
        </div>
      
    </div>

   <div className='SA-sidebar-menu'>
    
    
    <div className='SA-sidebar-link'>
    <i class="fa-solid fa-user-plus"></i>&nbsp; &nbsp;
        <Link to="/Superventures">Ventures</Link>
    </div>

    {/* <div className='SA-sidebar-link'>
    <i class="fa-solid fa-section"></i>&nbsp; &nbsp;
    <Link to="/Superusers">Users</Link>
        
    </div> */}
 
  
    <div className='SA-sidebar-link'>
    <i class="fa-solid fa-user"></i>&nbsp; &nbsp;&nbsp;&nbsp;
    <Link to="/Superprofile">Profile</Link>

    </div>
   
    
  <div className='SA-sidebar-link'>
    <i class="fa-solid fa-right-from-bracket"></i>&nbsp; &nbsp;&nbsp;&nbsp;
    <Link to ="" onClick={openLogForm}>Logout</Link> 
    </div>
   
    
   </div>

    </div>
    );
}

export default Sasidebar;